<div class="iq-fancy-box iq-works-box text-center">
  <div class="iq-icon">
    <ng-content select="[cardMedia]"></ng-content>
  </div>
  <div class="fancy-content">
    <ng-content select="[cardBody]"></ng-content>
  </div>
</div>
